import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type AddVehicleMutationVariables = {
  provingId: Types.Scalars['String'],
  input: Types.VehicleInsertInput
};


export type AddVehicleMutation = (
  { __typename?: 'Mutation' }
  & { addVehicle: (
    { __typename?: 'InternalVehicle' }
    & Pick<Types.InternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  ) | (
    { __typename?: 'ExternalVehicle' }
    & Pick<Types.ExternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  ) }
);

export type AddVehiclesMutationVariables = {
  provingId: Types.Scalars['String'],
  inputs: Array<Types.VehicleInsertInput>
};


export type AddVehiclesMutation = (
  { __typename?: 'Mutation' }
  & { addVehicles: Array<(
    { __typename?: 'InternalVehicle' }
    & Pick<Types.InternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  ) | (
    { __typename?: 'ExternalVehicle' }
    & Pick<Types.ExternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  )> }
);

export type UpdateVehiclesMutationVariables = {
  provingId: Types.Scalars['String'],
  batch: Array<Types.VehicleBatchInput>
};


export type UpdateVehiclesMutation = (
  { __typename?: 'Mutation' }
  & { updateVehicles: Array<(
    { __typename?: 'InternalVehicle' }
    & Pick<Types.InternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  ) | (
    { __typename?: 'ExternalVehicle' }
    & Pick<Types.ExternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  )> }
);

export type DeleteVehiclesMutationVariables = {
  provingId: Types.Scalars['String'],
  idsToDelete: Array<Types.Scalars['String']>
};


export type DeleteVehiclesMutation = (
  { __typename?: 'Mutation' }
  & { deleteVehicles: Array<(
    { __typename?: 'InternalVehicle' }
    & Pick<Types.InternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  ) | (
    { __typename?: 'ExternalVehicle' }
    & Pick<Types.ExternalVehicle, '_id' | 'type' | 'unknown'>
    & { transport: Types.Maybe<(
      { __typename?: 'Transport' }
      & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
    )> }
  )> }
);

export type EqVehiclesQueryVariables = {
  model: Types.Scalars['String']
};


export type EqVehiclesQuery = (
  { __typename?: 'Query' }
  & { eqVehicles: Array<(
    { __typename?: 'EQVehicle' }
    & Pick<Types.EqVehicle, '_id' | 'id' | 'licensePlate' | 'internalLabel' | 'label' | 'vin' | 'type' | 'typeDescription' | 'derivative'>
  )> }
);

export type ExportToSapMutationVariables = {
  provingId: Types.Scalars['String'],
  vehicleId: Types.Scalars['String'],
  outboundTransportSender?: Types.Maybe<Types.Scalars['String']>,
  outboundTransportRecipient?: Types.Maybe<Types.Scalars['String']>,
  returnTransportSender?: Types.Maybe<Types.Scalars['String']>,
  returnTransportRecipient?: Types.Maybe<Types.Scalars['String']>
};


export type ExportToSapMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'exportToSAP'>
);

export const AddVehicleDocument = gql`
    mutation AddVehicle($provingId: String!, $input: VehicleInsertInput!) {
  addVehicle(provingId: $provingId, input: $input) {
    _id
    type
    unknown
    transport {
      transportType
      bookingStatus
    }
  }
}
    `;
export type AddVehicleMutationFn = ApolloReactCommon.MutationFunction<AddVehicleMutation, AddVehicleMutationVariables>;

    export function useAddVehicleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddVehicleMutation, AddVehicleMutationVariables>) {
      return ApolloReactHooks.useMutation<AddVehicleMutation, AddVehicleMutationVariables>(AddVehicleDocument, baseOptions);
    };
export type AddVehicleMutationHookResult = ReturnType<typeof useAddVehicleMutation>;
export type AddVehicleMutationResult = ApolloReactCommon.MutationResult<AddVehicleMutation>;
export type AddVehicleMutationOptions = ApolloReactCommon.BaseMutationOptions<AddVehicleMutation, AddVehicleMutationVariables>;
export const AddVehiclesDocument = gql`
    mutation AddVehicles($provingId: String!, $inputs: [VehicleInsertInput!]!) {
  addVehicles(provingId: $provingId, inputs: $inputs) {
    _id
    type
    unknown
    transport {
      transportType
      bookingStatus
    }
  }
}
    `;
export type AddVehiclesMutationFn = ApolloReactCommon.MutationFunction<AddVehiclesMutation, AddVehiclesMutationVariables>;

    export function useAddVehiclesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddVehiclesMutation, AddVehiclesMutationVariables>) {
      return ApolloReactHooks.useMutation<AddVehiclesMutation, AddVehiclesMutationVariables>(AddVehiclesDocument, baseOptions);
    };
export type AddVehiclesMutationHookResult = ReturnType<typeof useAddVehiclesMutation>;
export type AddVehiclesMutationResult = ApolloReactCommon.MutationResult<AddVehiclesMutation>;
export type AddVehiclesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddVehiclesMutation, AddVehiclesMutationVariables>;
export const UpdateVehiclesDocument = gql`
    mutation updateVehicles($provingId: String!, $batch: [VehicleBatchInput!]!) {
  updateVehicles(provingId: $provingId, batch: $batch) {
    _id
    type
    unknown
    transport {
      transportType
      bookingStatus
    }
  }
}
    `;
export type UpdateVehiclesMutationFn = ApolloReactCommon.MutationFunction<UpdateVehiclesMutation, UpdateVehiclesMutationVariables>;

    export function useUpdateVehiclesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVehiclesMutation, UpdateVehiclesMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateVehiclesMutation, UpdateVehiclesMutationVariables>(UpdateVehiclesDocument, baseOptions);
    };
export type UpdateVehiclesMutationHookResult = ReturnType<typeof useUpdateVehiclesMutation>;
export type UpdateVehiclesMutationResult = ApolloReactCommon.MutationResult<UpdateVehiclesMutation>;
export type UpdateVehiclesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateVehiclesMutation, UpdateVehiclesMutationVariables>;
export const DeleteVehiclesDocument = gql`
    mutation deleteVehicles($provingId: String!, $idsToDelete: [String!]!) {
  deleteVehicles(provingId: $provingId, idsToDelete: $idsToDelete) {
    _id
    type
    unknown
    transport {
      transportType
      bookingStatus
    }
  }
}
    `;
export type DeleteVehiclesMutationFn = ApolloReactCommon.MutationFunction<DeleteVehiclesMutation, DeleteVehiclesMutationVariables>;

    export function useDeleteVehiclesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteVehiclesMutation, DeleteVehiclesMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteVehiclesMutation, DeleteVehiclesMutationVariables>(DeleteVehiclesDocument, baseOptions);
    };
export type DeleteVehiclesMutationHookResult = ReturnType<typeof useDeleteVehiclesMutation>;
export type DeleteVehiclesMutationResult = ApolloReactCommon.MutationResult<DeleteVehiclesMutation>;
export type DeleteVehiclesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteVehiclesMutation, DeleteVehiclesMutationVariables>;
export const EqVehiclesDocument = gql`
    query EQVehicles($model: String!) {
  eqVehicles(model: $model) {
    _id
    id
    licensePlate
    internalLabel
    label
    vin
    type
    typeDescription
    derivative
  }
}
    `;

    export function useEqVehiclesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EqVehiclesQuery, EqVehiclesQueryVariables>) {
      return ApolloReactHooks.useQuery<EqVehiclesQuery, EqVehiclesQueryVariables>(EqVehiclesDocument, baseOptions);
    };
      export function useEqVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EqVehiclesQuery, EqVehiclesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<EqVehiclesQuery, EqVehiclesQueryVariables>(EqVehiclesDocument, baseOptions);
      };
      
export type EqVehiclesQueryHookResult = ReturnType<typeof useEqVehiclesQuery>;
export type EqVehiclesQueryResult = ApolloReactCommon.QueryResult<EqVehiclesQuery, EqVehiclesQueryVariables>;
export const ExportToSapDocument = gql`
    mutation exportToSAP($provingId: String!, $vehicleId: String!, $outboundTransportSender: String, $outboundTransportRecipient: String, $returnTransportSender: String, $returnTransportRecipient: String) {
  exportToSAP(provingId: $provingId, vehicleId: $vehicleId, outboundTransportSender: $outboundTransportSender, outboundTransportRecipient: $outboundTransportRecipient, returnTransportSender: $returnTransportSender, returnTransportRecipient: $returnTransportRecipient)
}
    `;
export type ExportToSapMutationFn = ApolloReactCommon.MutationFunction<ExportToSapMutation, ExportToSapMutationVariables>;

    export function useExportToSapMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportToSapMutation, ExportToSapMutationVariables>) {
      return ApolloReactHooks.useMutation<ExportToSapMutation, ExportToSapMutationVariables>(ExportToSapDocument, baseOptions);
    };
export type ExportToSapMutationHookResult = ReturnType<typeof useExportToSapMutation>;
export type ExportToSapMutationResult = ApolloReactCommon.MutationResult<ExportToSapMutation>;
export type ExportToSapMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportToSapMutation, ExportToSapMutationVariables>;